import { FormEvent, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { api } from '../api';
import { useAuth } from '../auth';

export function LoginPage() {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await api.login(email, password);
      await refresh();
      const from = (location.state as { from?: { pathname: string } } | null)?.from?.pathname ?? '/';
      navigate(from, { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Ошибка входа');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="auth-container">
      <a className="auth-logo" href="/">
        <img src="/logo.png" alt="OrbanVPN" width="72" height="72" />
        <span className="brand-name">OrbanVPN</span>
      </a>
      <h1>Вход в личный кабинет</h1>
      <div className="card">
        <form onSubmit={onSubmit}>
          <div className="form-row">
            <label htmlFor="email">Email</label>
            <input id="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="form-row">
            <label htmlFor="password">Пароль</label>
            <input id="password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          {error && <div className="error">{error}</div>}
          <div className="auth-actions">
            <button type="submit" className="btn-block" disabled={submitting}>Войти</button>
            <Link to="/register" className="btn btn-block secondary" role="button">Зарегистрироваться</Link>
          </div>
        </form>
      </div>
      <div className="auth-meta">
        <Link to="/reset">Забыли пароль?</Link>
      </div>
    </div>
  );
}
